import { routesProfile } from '../consts'

const DEFAULT_FALLBACK = routesProfile.ROOT.path

/**
 * Безопасный относительный путь для client-side редиректа (защита от open redirect).
 */
export function getSafeReturnPath(
  candidate: string | undefined,
  fallback: string = DEFAULT_FALLBACK,
): string {
  if (candidate == null) {
    return fallback
  }
  const trimmed = candidate.trim()
  if (trimmed.length === 0) {
    return fallback
  }
  if (!trimmed.startsWith('/')) {
    return fallback
  }
  if (trimmed.startsWith('//') || trimmed.includes('://')) {
    return fallback
  }
  if (trimmed.includes('\\') || trimmed.includes('\0')) {
    return fallback
  }
  return trimmed
}
